import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { get } from 'lodash'

import ErrorMessage from './ErrorMessage'
import { useFormContext } from '@context/FormContext'

const Textarea = ({ name, label, autoresize = true, autocomplete = 'off', ...props }) => {
  const { values, errors, submitCount, setFieldValue } = useFormContext()
  
  const fieldValue = get(values, name) || ''
  const fieldError = get(errors, name)
  // Only show errors after user tries to submit (submitCount > 0)
  const fieldTouched = submitCount > 0

  const handleInput = (e) => {
    if (autoresize) {
      const offset = e.target.offsetHeight - e.target.clientHeight
      e.target.style.height = 'auto'
      e.target.style.height = e.target.scrollHeight + offset + 'px'
    }
  }

  const handleChange = (e) => {
    setFieldValue(name, e.target.value)
    props.onChange && props.onChange(e.target.value)
  }

  return (
    <div
      className={classNames(
        'mb-4',
        { 'opacity-60': props.disabled },
        { 'has-error': fieldError && fieldTouched },
        { 'has-success': !fieldError && fieldTouched },
      )}
    >
      {label && (
        <label className="form-label" htmlFor={name}>
          {label}
        </label>
      )}

      <textarea
        {...props}
        id={name}
        name={name}
        className={classNames(
          'form-input',
          { 'error': fieldError && fieldTouched },
          { 'valid': !fieldError && fieldTouched },
          props.className
        )}
        onInput={handleInput}
        onChange={handleChange}
        rows={props.rows || 3}
        value={fieldValue}
      />

      <ErrorMessage render={!!(fieldError && fieldTouched)} message={fieldError} />
    </div>
  )
}

Textarea.propTypes = {
  name: PropTypes.string.isRequired,
  autocomplete: PropTypes.string,
  autofocus: PropTypes.bool,
  autoresize: PropTypes.bool,
  disabled: PropTypes.bool,
  label: PropTypes.string,
  max: PropTypes.number,
  min: PropTypes.number,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  rows: PropTypes.number,
  className: PropTypes.string,
}

export default Textarea
